<ion-card class="metrics-card">
  <ion-card-header class="metrics-card-header" wilsonFitText>
    {{ header() }}
  </ion-card-header>
  @if (!loading()) {
    <ion-card-content class="metrics-card-content">
      <div class="metrics-card-value" wilsonFitText>
        @for (value of values(); track $index; let last = $last) {
          @if (unit() === PayrollUnitName.Eur) {
            {{ value! | currency: 'EUR' : 'symbol' : '1.0-1' : currentLang() }}
          } @else if (unit() === PayrollUnitName.Gbp) {
            {{ value! | currency: 'GBP' : 'symbol' : '1.0-1' : currentLang() }}
          } @else if (unit() === PayrollUnitName.Hour) {
            {{ value! | minutesToHoursMinutes }}
          } @else {
            {{ value! | number: '1.0-1' : currentLang() }}
            @if (unit() === PayrollUnitName.Day) {
              {{ 'general.days' | translate }}
            }
          }
          @if (!last) {
            {{ separator() }}
          }
        }
      </div>
    </ion-card-content>
  } @else {
    <div class="loading-state">
      <ion-skeleton-text
        [animated]="true"
        class="subtitle-skeleton"
      ></ion-skeleton-text>
    </div>
  }
</ion-card>
